<div class="grid filter" *ngIf="showFilter()">
  <div class="col-4 searchLabel" *ngIf="labelNeedTranslation()">
    {{'LABEL.GIVEN.BY.BACK.'+criteria.sNameI18n | translate}}
  </div>
  <div class="col-4 searchLabel" *ngIf="!labelNeedTranslation()">
    {{criteria.sNameI18n}}
  </div>
  <div class="col-2 searchDropdown">
    <p-dropdown [options]="options" [(ngModel)]="selectedOperator" (change)="updateCriteria()"></p-dropdown>
  </div>
  <div class="col-6 searchInput" [ngClass]="{'notUpToDate': valueFieldIsNotUpToDate }" *ngIf="criteria.sNameId === 'motifPND'">
    <p-dropdown [options]="motifOptions" (onChange)="setMotifValue($event)"></p-dropdown>
  </div>
  <div class="col-6 searchInput" *ngIf="criteria.sTypeData === 'date'"
       [ngClass]="{'requestedField': customPeriodEntryIsNotValid() }">
    <p-calendar #customPeriodCal [(ngModel)]="selectedDates" [dateFormat]="'dd/mm/yy'" [selectionMode]="'range'"
                [readonlyInput]="true" [showButtonBar]="true"
                (onSelect)="updateCriteria()"
                (onClearClick)="clearCriteria()"
                [showIcon]="true" [minDate]="yearRange[0]" [maxDate]="yearRange[1]"></p-calendar>
  </div>
  <div class="col-6 searchInput" [ngClass]="{'notUpToDate': valueFieldIsNotUpToDate }" *ngIf="(criteria.sNameId !== 'motifPND' && criteria.sTypeData !=='date' && criteria.sNameId !== 'Modèle du mail')">
    <input pInputText class="inputQuerry" type="text" [(ngModel)]="criteria.sCriteriaTrackingValue" (change)="updateCriteria()">
  </div>

  <div class="col-6 searchInput" [ngClass]="{'notUpToDate': valueFieldIsNotUpToDate }" *ngIf="(criteria.sNameId !== 'motifPND' && criteria.sTypeData !=='date' && criteria.sNameId === 'Modèle du mail')">
    <p-dropdown id="template" [options]="emailTemplates" [style]="{'text-align': 'center','width':'100% !important'}"
                [(ngModel)]="selectedEmailTemplateValue" [group]="true"
                [autoDisplayFirst]="false" (onChange)="updateCriteriaForEmailTemplate()"></p-dropdown>
  </div>
</div>
